<template>
  <div>
    <signature-hub
      :cancel-document="cancelDocument"
      :participants="participants"
      :print-action-text="getNameButtonPrint"
      :related-id="relatedId"
      :resend-invitation="resendInvitation"
      :save-signature-hub="saveSignatureHub"
      :search-user-email="searchUserEmail"
      :send-document="sendDocument"
      :signature-hub-info="signatureHubInfo"
      :type-id="typeId"
      :user-profile-info="userProfileInfo"
      @document-cancelled="handleDocumentCancelled"
      @go-back="handleGoBack"
      @print="handlePrint"
      @saved="handleSaved"
      @update-signature="handleUpdateSignature"
    />
  </div>
</template>

<script>
// libs
import { SignatureHub } from '@quisit/signature-hub';

// services
import {
  searchUserEmail as _searchUserEmail,
  saveSignatureHub as _saveSignatureHub,
  getSignatureHubInfo as _getSignatureHubInfo,
  sendDocument as _sendDocument,
  resendInvitation as _resendInvitation,
  cancelDocument as _cancelDocument,
  getSignedDocument as _getSignedDocument,
} from '@/services/signatureHub/api.js';
import _generalApi from '@/services/pei/general.js';
import signatureHubTypes from '@/utils/constants/signatureHubTypes.js';

//utils
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'MainSignatureHub',
  components: {
    SignatureHub,
  },
  mixins: [alertMixin],
  data() {
    return {
      participants: [],
      signatureHubInfo: null,
      from: 'signature-hub',
      fromData: {
        tabModel: 1,
      },
      query: {},
      returnTo: null, // { name, params, query }
    };
  },
  computed: {
    getNameButtonPrint() {
      if (this.typeId === signatureHubTypes.INTERVENTION_PLAN) {
        return 'Imprimir Plan';
      }
      if (this.typeId === signatureHubTypes.ADMISSION_NOTE) {
        return 'Imprimir Nota de Admisión';
      }
      if (this.typeId === signatureHubTypes.INTERVENTION_PLAN_PERIOD) {
        return 'Imprimir Informe de Logros';
      }
      return 'Imprimir';
    },
    typeId() {
      return this.$route.params.typeId;
    },
    relatedId() {
      return `${this.$route.params.relatedId}`;
    },
    userProfileInfo() {
      return {
        userId: this.userProfile.sub,
        userName: this.userProfile.name,
        name: this.userProfile.givenname,
        email: this.userProfile.email,
      };
    },
  },
  beforeRouteEnter(to, from, next) {
    const p = to.params || {};
    const q = to.query || {};

    if (p.from === 'medical-plan') {
      const studentSieId =
        p.studentSieId || p.fromData?.studentSieId || q.studentSieId;

      const returnTo = studentSieId
        ? {
            name: 'medical-plan',
            params: { studentSieId },
            query: { ...q, tab: 0 },
          }
        : null;

      return next((vm) => {
        vm.returnTo = returnTo;
      });
    }

    return next((vm) => {
      vm.returnTo = null;
    });
  },
  async mounted() {
    await this.fetchSignatureHubInfo();
  },
  methods: {
    async handleGoBack() {
      if (this.returnTo) {
        return this.$router.push(this.returnTo).catch((e) => {
          if (e?.name === 'NavigationDuplicated') return;
        });
      }

      this.$router.go(-1);
    },
    async handleSaved() {
      await this.fetchSignatureHubInfo();
    },
    async handleDocumentCancelled() {
      await this.fetchSignatureHubInfo();
    },
    async handleUpdateSignature() {
      await this.fetchSignatureHubInfo();
    },
    async handlePrint({ typeId, relatedId, documentId }) {
      if ((typeId, relatedId, documentId)) {
        const response = await _getSignedDocument(
          typeId,
          relatedId,
          documentId
        ).catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
        if (response?.data) {
          _generalApi.downloadDocument(response.data);
        }
      }
    },
    async fetchSignatureHubInfo() {
      const response = await _getSignatureHubInfo(this.typeId, this.relatedId);
      if (response?.data) {
        this.signatureHubInfo = {
          ...response.data,
          participants: response.data.participants.map((participant) => ({
            ...participant,
            selectedOther:
              (participant?.accounts?.length &&
              !participant?.accounts?.some((a) => a.email === participant.email)
                ? 1
                : null) || !participant.accounts?.length,
            searchEmailSnapshot: {
              input: participant.email,
              data: [],
            },
            userAccount: null,
          })),
        };
      }
    },
    searchUserEmail(params) {
      return _searchUserEmail(params);
    },
    saveSignatureHub(payload) {
      return _saveSignatureHub(payload);
    },
    sendDocument(typeId, relatedId) {
      return _sendDocument(typeId, relatedId);
    },
    resendInvitation(payload) {
      return _resendInvitation(payload);
    },
    cancelDocument(typeId, relatedId, payload) {
      return _cancelDocument(typeId, relatedId, payload);
    },
  },
};
</script>
